export const GENDER_OPTIONS = [
  { id: 'HOMEM', label: 'Homem', apiValue: 'Masculino' },
  { id: 'MULHER', label: 'Mulher', apiValue: 'Feminino' },
  { id: 'HOMEM_TRANS', label: 'Homem transgênero', apiValue: 'Homem transgênero' },
  { id: 'MULHER_TRANS', label: 'Mulher transgênero', apiValue: 'Mulher transgênero' },
  { id: 'NAO_BINARIO', label: 'Não binário', apiValue: 'Não binário' },
  { id: 'OUTRO', label: 'Outro', apiValue: 'Prefiro não responder' }
]

export const getGenderApiValue = (id) => {
  const option = GENDER_OPTIONS.find((gender) => gender.id === id)
  return option ? option.apiValue : id
}
